import type { OrderStoreState } from "../stores/order.store";
import type { Address } from "./address.types";
import type { SavedFile } from "./files.types";
import type { ActivityLog } from "./logs.types";
import type { Patient } from "./patient.types";
import type { PurchaseOrder } from "./purchase_orders.types";

export enum CommandStatus {
	DRAFT = "DRAFT",
	WAITING_FOR_RECEPTION = "WAITING_FOR_RECEPTION",
	RECEIVED = "RECEIVED",
	WAITING_FOR_MODELING = "WAITING_FOR_MODELING",
	MODELING = "MODELING",
	WAITING_FOR_PRINTING = "WAITING_FOR_PRINTING",
	PRINTING = "PRINTING",
	PRINTED = "PRINTED",
	WAITING_FOR_LAB = "WAITING_FOR_LAB",
	INJECTING = "INJECTING",
	POLISHING = "POLISHING",
	QUALITY_CONTROL = "QUALITY_CONTROL",
	READY = "READY",
	READY_FOR_DELIVERY = "READY_FOR_DELIVERY",
	PARCEL_PREPARED = "PARCEL_PREPARED",
	IN_DELIVERY = "IN_DELIVERY",
	DELIVERED = "DELIVERED",
	ABORTED = "ABORTED",
	PENDING = "PENDING",
}

export enum CommandType {
	THREED = "THREED",
	OTOSCAN = "OTOSCAN",
	POSTE = "POSTE",
	REWORK = "REWORK",
	SUPPLY = "SUPPLY",
}

export type Command = {
	id: number;
	exposedId: string;
	createdAt: Date;
	updatedAt: Date;
	deliveredAt: Date | null;
	patientId: number; // patient
	patient?: Patient; // patient
	status: CommandStatus;
	type: CommandType;
	creatorId: number; // user
	creator: {
		firstName: string;
		lastName: string;
	};
	externalId?: string;
	centerId: number; // center
	center: {
		name?: string;
		phoneNumber?: string;
		enterprise?: {
			name?: string;
		};
	};
	haltedAt: Date;
	haltedReason: string;
	haltedExplanation: string;
	billingAddressId: number | null;
	billingAddress?: Address;
	shippingAddressId: number | null;
	shippingAddress?: Address;
	company?: string;
	activityLogs: ActivityLog[];
	managerId: number; // user
	modelerId: number; // user
	draft?: OrderStoreState;
	purchaseOrderFileId: number | null;
	purchaseOrderFile?: SavedFile;
	purchaseOrderId: number | null;
	purchaseOrder?: PurchaseOrder;
	discount: number | null;
	conformityNoteFileId: number | null;
	conformityNoteFile?: SavedFile;
	informationSheetFileId: number | null;
	informationSheetFile?: SavedFile;
	labelFileId: number | null;
	labelFile?: SavedFile;
	isPriority: boolean;
	expectedShippingDate: string | Date;
	groupExpectedShippingDate: string | Date;
	material?: "SILICONE" | "RESIN";
};

export type CommandTracking = {
	datetime: string;
	location: {
		slic?: string;
		address?: {
			countryCode?: string;
			country?: string;
			city?: string;
		};
	};
	status: {
		type?: string;
		description?: string;
		code?: string;
		statusCode?: string;
	};
};
